import { message } from 'antd'
import DocumentsApi from '../../../../api/Documents'
import Email from '../../../../api/Email'
import { PayrollClaimApi } from '../../../../api/People/PayrollClaim'
import Templates from '../../../../api/Templates'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import { isEmpty, pick } from 'lodash'
import { get } from 'lodash'
import { dateVal } from '../../../../modules/Utils'
import React, { useState } from 'react'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { withRouter } from 'react-router-dom'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import AddPayrollClaim from '../../../../components/People/PayrollClaim/AddPayrollClaim/AddPayrollClaim'
import { MODAL_TYPE_EDIT } from '../../../../elements/Hooks/useModalData'
import { MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import useModalData from '../../../../elements/Hooks/useModalData'

const docsApi = new DocumentsApi()
const templateApi = new Templates()
const emailApi = new Email()

function AddPayrollClaimCont(props) {
  const key = get(props.match, 'params.key')
  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW

  const { fetch, fetching, object: payrollClaim, setObject: setPayrollClaim } = useFetchObject(
    () => PayrollClaimApi.get(key),
    false,
    [key],
    isEmpty(key)
  )
  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('payrollClaims', payrollClaim.status),
    [payrollClaim.status, isEmpty(payrollClaim.status)]
  )

  const [submittingOperation, submitOperation] = useSubmit(PayrollClaimApi.operation)
  const [removing, removeFunc] = useSubmit(PayrollClaimApi.remove)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    if (operation === 'remove') {
      const removed = await removeFunc({
        ...pick(payrollClaim, ['_key', '_rev', '_id']),
      })
      if (removed)
        props.history.replace({
          pathname: `/people/payrollClaims/`,
        })
    } else {
      const ObjectDB = await submitOperation({
        status: operation,
        ...pick(payrollClaim, ['_key', '_rev', '_id']),
      })
      if (ObjectDB) setPayrollClaim({ ...ObjectDB, lines: payrollClaim.lines })
    }
    hide()
  }

  const isNew = type === MODAL_TYPE_NEW

  // send email
  const [SendingEmails, setSendingEmails] = useState(false)
  const [submittingTemplate, submitTemplate] = useSubmit(templateApi.read, true)
  const [submittingPayClaimTemplate, submitPayClaimTemplate] = useSubmit(
    emailApi.payClaimTemplate,
    true
  )
  const [submittingPayrollClaimFiles, submitPayrollClaimFiles] = useSubmit(
    PayrollClaimApi.files,
    true
  )

  async function onSendPayClaim() {
    // setSendingEmails(true)
    const date = dateVal(payrollClaim, 'date').format('DD-MM-YYYY')
    console.log({ date }, dateVal(payrollClaim, 'date'))
    try {
      const employees = payrollClaim.lines.map((p) => ({
        _id: p._id,
        salary: p.salary,
        fn: p.employee.fn,
        email: p.employee.email.label,
      }))
      console.log(payrollClaim.lines)
      console.log({ employees })
      const payrollClaimsTemplate = await submitTemplate('payrollClaims', 'payrollClaims')
      const emailDetails = get(payrollClaimsTemplate, 'email') || {}
      console.log({ emailDetails })

      employees.forEach(async (em) => {
        const data = await submitPayClaimTemplate({
          receiver: get(em, 'fn'),
          date: date,
          ...emailDetails,
        })

        const filesList = await submitPayrollClaimFiles([em.salary._id])

        await emailApi.issue({
          to: em.email,
          // to: 'mabdulaali@mondiale.com',
          from: 'hr@mondiale.com',
          subject: ` Salary Slip Paid on ${date}`,
          attachments: filesList,
          html: data.html,
        })
      })

      message.success('Sent')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        sending: false,
      })
      setSendingEmails(false)
    }
  }

  const {
    visible,
    modalType,
    object: line,
    submitting,
    submit,
    update,
    removing: removingLine,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
  } = useModalData(undefined, PayrollClaimApi.lines.update, PayrollClaimApi.lines.remove, fetch)
  const isUpdatable = actions.find((a) => a.key === 'update')
  const [pulling, pullData] = useSubmit(PayrollClaimApi.lines.pullData, true)

  async function onPullData() {
    const data = await pullData(line)
    if (data) {
      onCancel()
      fetch()
    }
  }

  //csv

  const {
    visible: visibleCSV,
    object: csv,
    formRef: formRefCSV,
    onShow: onShowCSV,
    onCancel: onCancelCSV,
    checkForm: checkFormCSV,
  } = useModalData(undefined, PayrollClaimApi.lines.update, PayrollClaimApi.lines.remove, fetch)
  const [fetchingCSV, getCSV] = useSubmit(PayrollClaimApi.csv)

  async function fetchCSV() {
    const data = await checkFormCSV()
    const csv = await getCSV(payrollClaim._key, data)
    if (!isEmpty(JSON.stringify(csv))) {
      onCancelCSV()
      fetch()
    }
  }

  return (
    <AddPayrollClaim
      {...{
        isNew,
        key,
        type,
        fetch,
        fetching,
        payrollClaim,
        actions,
        fetchingActions,
        fetchActions,
        submitting,
        submit,
        removing,
        update,
        handleActions,
        // lines
        visible,
        modalType,
        line,
        removingLine,
        remove,
        formRef,
        onShow,
        onCancel,
        checkForm,
        isUpdatable,
        onPullData,
        pulling,
        visibleCSV,
        csv,
        formRefCSV,
        onShowCSV,
        onCancelCSV,
        checkFormCSV,
        fetchingCSV,
        fetchCSV,
        onSendPayClaim,
        SendingEmails,
      }}
    />
  )
}

AddPayrollClaim.propTypes = {}
AddPayrollClaim.defaultProps = {}

export default withRouter(AddPayrollClaimCont)
